
import React from 'react';
import InstagramIcon from './icons/InstagramIcon';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#0a3d34] py-8 text-center text-[#f0e1b2]">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center space-y-4">
          <div className="font-serif text-2xl font-bold">Urban Zaikha</div>
          <a 
            href="https://instagram.com/urbanzaikha" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white transition-colors duration-300"
          >
            <InstagramIcon className="w-8 h-8" />
          </a>
          <p className="text-sm text-gray-400">&copy; {new Date().getFullYear()} Urban Zaikha. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
